import Logger from 'Logger'
import Backbone from 'backbone'
import _ from 'underscore'
import { GOODS_ID } from '../../config'
import { popShow } from '../../manager/mall.event'
import { detailHandler, openPayPopup } from '../../manager/view.handler'
import { loadingModel } from '../../store/loding.model'
import { eventBus, multiFactorAuthenticate } from '../../utils'
import { parseSettings } from '../../utils/settings'
import detailLink from '../template/part.detailLink.mustache'
import { GachaGame, LADDER_GAME, LUCKY_CARD } from './gacha-game'
import { GachaCollection } from './gacha.collection'
import tpl from './gacha.mustache'

/** 뽑기 상품 플레이 뷰 */
export var GachaView = Backbone.View.extend({
  tagName: 'div',
  className: 'GachaView',
  collection: new GachaCollection(),
  template: tpl,
  events: {
    'click [data-id]': openPayPopup,
    'click [data-detail-pop]': detailHandler,
    'click [data-gacha-name]': 'handleGacha',
  },
  initialize: function () {
    this.collection.once('sync', this.render, this)
    this.collection.fetch()

    eventBus.off('GachaView:open')
    eventBus.on('GachaView:open', _.bind(this.handleGacha, this))
  },
  render: function () {
    var data = this.collection.map(
      _.bind(function (model) {
        var isLuckyCard = _.includes(GOODS_ID.LUCKY_DRAW, model.get('goods_id'))
        return _.extend(model.toJSON(), { isLuckyCard: isLuckyCard })
      }, this)
    )

    var rendered = this.template.render(
      {
        items: data,
      },
      { detailLink: detailLink }
    )
    this.$el.empty().append(rendered)

    return this
  },

  /**
   * 이 뷰의 버튼을 클릭해서 실행
   *  또는 eventBus.trigger('GachaView:open', { gachaName: '가챠명' })로 실행
   */
  handleGacha: function (e) {
    if (_.isFunction(e.preventDefault)) {
      e.preventDefault()
    }

    var $target = $(e.currentTarget)
    var context = $target.data('gachaName') || e.gachaName // 클릭 이벤트 또는 eventBus trigger로 이벤트가 넘어왔을 때
    var settings = parseSettings()

    if (context === LUCKY_CARD) {
      launchGachaGame(new GachaGame(settings.env, LUCKY_CARD)) // 행운 카드 뽑기
    } else if (context === LADDER_GAME) {
      launchGachaGame(new GachaGame(settings.env, LADDER_GAME)) // 사다리 타기
    } else {
      Logger.info('No Gacha!')
      loadingModel.endLoading()
    }
  },
})

/**
 * @param {import('./gacha-game.js').GachaGame} gachaGame
 */
function launchGachaGame(gachaGame) {
  multiFactorAuthenticate()
    .then(() => {
      loadingModel.startLoading()
      return gachaGame.init()
    })
    .catch(function (err) {
      gachaGame.close()
      // 보안서비스 인증 실패시 넘어오는 에러
      if (!err || err.message !== 'mall/authFailed') {
        Logger.info(err)
        popShow({
          message:
            '일시적인 에러가 발생하였습니다. : ' + err.message || '(없음)',
        })
      }
    })
    .finally(() => {
      loadingModel.endLoading()
    })
}
